import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image, Anchor } from "hesus-ui-kit";
import { avatarIcons, avatarIconsMr, avatarIconsMs } from "@utils/avatarInfo";
import { RefrentInfo, GridRowNoGap, FlexRow } from "./PersonDetail.styled";
import "../../../../QuoteView.scss";

const PersonDetail = (props) => {
  const { t, contactInfo } = props;
  const [avatarImage, setAvatarImage] = useState(avatarIcons[1]);
  const avatarNumber = Math.floor(Math.random() * 10);

  useEffect(() => {
    if (contactInfo?.contact.courtesy === "MISTER") {
      setAvatarImage(avatarIconsMr[avatarNumber] ?? avatarIcons[1]);
    } else if (contactInfo?.contact.courtesy === "MISS") {
      setAvatarImage(avatarIconsMs[avatarNumber] ?? avatarIcons[4]);
    } else {
      setAvatarImage(avatarIcons[avatarNumber] ?? avatarIcons[1]);
    }
  }, []);

  return (
    <FlexRow>
      <Image src={avatarImage} className="quote_view__image-icon" />
      <GridRowNoGap column="1fr">
        <RefrentInfo
          color="#474747"
          size="22px"
          weight="700"
          lineHeight="26px"
          paddingLeft="10px"
        >
          {contactInfo?.contact?.firstName
            ? contactInfo?.contact.firstName +
              " " +
              contactInfo?.contact.lastName
            : "-"}
        </RefrentInfo>
        <RefrentInfo
          color="#767676"
          size="12px"
          weight="700"
          lineHeight="18px"
          paddingLeft="10px"
        >
          {contactInfo?.contact?.phone ?? ""}
          {contactInfo?.contact?.phone && contactInfo?.contact?.mobilePhone
            ? " / " + contactInfo?.contact.mobilePhone
            : contactInfo?.contact?.mobilePhone ?? "-"}
        </RefrentInfo>
        <RefrentInfo
          color="#1BACE4 !important"
          size="12px"
          weight="700"
          lineHeight="18px"
          paddingLeft="10px"
        >
          {contactInfo?.contact?.email ? (
            <Anchor
              url={`mailto:${contactInfo?.contact?.email}`}
              className="quote_view__person-detail-link"
            >
              {contactInfo?.contact?.email}
            </Anchor>
          ) : (
            ""
          )}
        </RefrentInfo>
      </GridRowNoGap>
    </FlexRow>
  );
};
PersonDetail.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PersonDetail);
